import { render, staticRenderFns } from "./Circle.vue?vue&type=template&id=bdf1b9a8&scoped=true"
import script from "./Circle.vue?vue&type=script&lang=js"
export * from "./Circle.vue?vue&type=script&lang=js"
import style0 from "./Circle.vue?vue&type=style&index=0&id=bdf1b9a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdf1b9a8",
  null
  
)

export default component.exports